<template>
  <div class="menuContainer">
    <p class="title">个人存款</p>
    <el-menu
      :default-active="activeProduct"
      class="el-menu-demo"
      mode="vertical"
      unique-opened
      router
      text-color="#333"
      @open="handleMenuOpen"
    >
      <el-menu-item index="/personalDeposit/certificateDeposit"
        >个人大额存单</el-menu-item
      >
      <el-submenu index="/personalDeposit/flexibleProfit">
        <template slot="title">华兴特色存款 </template>
        <el-menu-item index="/personalDeposit/flexibleProfit"
          >灵活盈</el-menu-item
        >
        <el-menu-item index="/personalDeposit/secureDeposit"
          >安兴存</el-menu-item
        >
      </el-submenu>
      <el-submenu index="/personalDeposit/wholeDepositAndWithdraw">
        <template slot="title">传统储蓄存款</template>
        <el-menu-item index="/personalDeposit/wholeDepositAndWithdraw"
          >整存整取</el-menu-item
        >
        <el-menu-item index="/personalDeposit/callDeposit"
          >通知存款</el-menu-item
        >
      </el-submenu>
    </el-menu>
  </div>
</template>

<script>
export default {
  computed: {
    activeProduct() {
      return this.$route.path
    },
  },
  methods: {
    handleMenuOpen(index) {
      this.$router.push(index)
    },
  },
}
</script>

<style lang="scss"></style>
